var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_vm.category ? _c('div', {
    staticClass: "mb-30px mb-md-40px"
  }, [_c('v-btn-toggle', {
    staticClass: "w-100",
    attrs: {
      "light": true
    }
  }, [_c('v-row', {
    staticClass: "row-cols-md-5 my-n4px",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-4px"
  }, [_c('v-btn', {
    class: _vm.filter._category == _vm.category._id ? 'primary' : 'v-btn--outlined grey--text',
    attrs: {
      "block": "",
      "x-large": ""
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory(_vm.category._id);
      }
    }
  }, [_c('span', {
    class: _vm.filter._category == _vm.category._id ? '' : 'grey--text text--darken-3'
  }, [_vm._v("전체")])])], 1), _vm._l(_vm.category.children, function (category) {
    return [_c('v-col', {
      key: category._id,
      staticClass: "py-4px"
    }, [_c('v-btn', {
      class: _vm.filter._category == category._id ? 'primary' : 'v-btn--outlined grey--text',
      attrs: {
        "block": "",
        "x-large": ""
      },
      on: {
        "click": function click($event) {
          return _vm.setCategory(category._id);
        }
      }
    }, [_c('span', {
      class: _vm.filter._category == category._id ? '' : 'grey--text text--darken-3'
    }, [_vm._v(_vm._s(category.name))])])], 1)];
  })], 2)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "best-slide-wrap"
  }, [_c('div', {
    staticClass: "best-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.bestOfBests, function (product) {
    return _c('div', {
      key: product._id,
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      attrs: {
        "to": "/shop/bestseller/".concat(product._id)
      }
    }, [_c('div', {
      staticClass: "best-slide__img",
      style: 'background-image:url(' + product.thumb + ');'
    }), _c('div', {
      staticClass: "mt-4 text-center grey--text text--darken-4"
    }, [_c('div', {
      staticClass: "font-size-18 font-size-md-20 font-weight-medium text-truncate"
    }, [_vm._v(_vm._s(product.name))]), _c('v-layout', {
      staticClass: "font-size-14 text-truncate mt-1",
      attrs: {
        "justify-center": ""
      }
    }, [_c('span', [_vm._v(_vm._s(product.writer))]), product.writer && product.publisher ? _c('v-divider', {
      staticClass: "mx-2 my-1",
      attrs: {
        "vertical": ""
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(product.publisher))])], 1)], 1)])], 1);
  }), 0)]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-prev"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-chevron-left")])], 1), _c('div', {
    staticClass: "swiper-next"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-chevron-right")])], 1)])])]), _c('div', {
    staticClass: "mt-30px"
  }, [_c('v-divider', {
    staticClass: "border-2 grey lighten-1"
  }), _c('div', {
    staticClass: "py-10px py-md-6px"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v(" 검색된 상품: "), _c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.summary.totalCount.format()))]), _vm._v("개 ")])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sortItems,
      "item-text": "text",
      "value": "value",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.search(false);
      }
    },
    model: {
      value: _vm.sort,
      callback: function callback($$v) {
        _vm.sort = $$v;
      },
      expression: "sort"
    }
  })], 1)], 1)], 1), _c('v-divider', {
    staticClass: "grey lighten-1"
  })], 1), _c('div', {
    staticClass: "py-20px py-md-30px"
  }, [_c('v-row', _vm._l(_vm.products, function (product) {
    return _c('v-col', {
      key: product._id,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: "/shop/bestseller/".concat(product._id),
          query: Object.assign({}, _vm.filter)
        }
      }
    }, [_c('v-img', {
      staticClass: "mx-auto",
      attrs: {
        "src": product.thumb,
        "width": "100%",
        "aspect-ratio": 200 / 160,
        "contain": ""
      }
    }), _c('div', {
      staticClass: "mt-4 text-center grey--text text--darken-4"
    }, [_c('div', {
      staticClass: "font-size-18 font-size-md-20 font-weight-medium text-truncate"
    }, [_vm._v(_vm._s(product.name))]), _c('v-layout', {
      staticClass: "font-size-14 text-truncate mt-1",
      attrs: {
        "justify-center": ""
      }
    }, [_c('span', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(product.writer))]), product.writer && product.publisher ? _c('v-divider', {
      staticClass: "mx-2 my-1",
      attrs: {
        "vertical": ""
      }
    }) : _vm._e(), _c('span', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(product.publisher))])], 1), _c('div', {
      staticClass: "d-flex align-center justify-center primary--text mt-md-1"
    }, [_c('span', {
      staticClass: "font-size-16 font-size-md-18 font-weight-bold"
    }, [_vm._v(_vm._s(product.salePrice.format()))]), _c('small', {
      staticClass: "font-size-14 font-weight-medium ml-1"
    }, [_vm._v("원")])]), _c('v-layout', {
      staticClass: "mt-2 mr-n1",
      attrs: {
        "wrap": "",
        "justify-center": ""
      }
    }, [product.isRecommend ? _c('v-flex', {
      staticClass: "pr-1",
      attrs: {
        "shrink": ""
      }
    }, [_c('v-chip', {
      attrs: {
        "color": "#FA647D",
        "dark": "",
        "x-small": ""
      }
    }, [_vm._v("추천")])], 1) : _vm._e(), product.isNewly ? _c('v-flex', {
      staticClass: "pr-1",
      attrs: {
        "shrink": ""
      }
    }, [_c('v-chip', {
      attrs: {
        "color": "#FFAE00",
        "dark": "",
        "x-small": ""
      }
    }, [_vm._v("신상품")])], 1) : _vm._e(), product.isPopular ? _c('v-flex', {
      staticClass: "pr-1",
      attrs: {
        "shrink": ""
      }
    }, [_c('v-chip', {
      attrs: {
        "color": "#32C081",
        "dark": "",
        "x-small": ""
      }
    }, [_vm._v("인기")])], 1) : _vm._e(), product.isBest ? _c('v-flex', {
      staticClass: "pr-1",
      attrs: {
        "shrink": ""
      }
    }, [_c('v-chip', {
      attrs: {
        "color": "#1AB5BB",
        "dark": "",
        "x-small": ""
      }
    }, [_vm._v("베스트")])], 1) : _vm._e()], 1)], 1)], 1)], 1);
  }), 1)], 1), _c('v-divider', {
    staticClass: "border-2 grey lighten-1"
  }), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11",
      "color": "primary"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }